module.exports = __webpack_public_path__ + "static/media/icon-pill-court-tennis.47217cfc.svg";